import { Avatar, Heading, Icon, Muted, Text, ThemeToggle } from '@fluent/ui';
import './Cluster6Review.css';

export function Cluster6Review() {
  return (
    <main className="c6">
      <header className="c6__hero">
        <p className="c6__kicker">Phase 1 · Cluster 6</p>
        <Heading level={2} tone="inverse">
          Typography &amp; misc
        </Heading>
        <Text tone="inverse" size="base" className="c6__lede">
          The leaf pieces — headings, body text, avatar, icon wrapper. Unglamorous, used everywhere.
        </Text>
        <div className="c6__theme-row">
          <ThemeToggle />
        </div>
      </header>

      {/* Headings */}
      <section className="c6__section">
        <Heading level={3}>Heading</Heading>
        <Muted>5 levels. Nunito + FiraGO, 900 weight for 1–2, 800 for 3–5.</Muted>
        <div className="c6__stack">
          <Heading level={1}>Level 1 · გამარჯობა</Heading>
          <Heading level={2}>Level 2 · ოჯახი</Heading>
          <Heading level={3}>Level 3 · საჭმელი</Heading>
          <Heading level={4}>Level 4 · რიცხვები</Heading>
          <Heading level={5}>Level 5 · ფერები</Heading>
        </div>

        <Muted className="c6__spacer">Tones</Muted>
        <div className="c6__stack">
          <Heading level={3}>default</Heading>
          <Heading level={3} tone="primary">primary</Heading>
          <Heading level={3} tone="accent">accent</Heading>
          <Heading level={3} tone="danger">danger</Heading>
          <Heading level={3} tone="muted">muted</Heading>
        </div>
      </section>

      {/* Text */}
      <section className="c6__section">
        <Heading level={3}>Text</Heading>
        <Muted>4 sizes × 4 weights × 7 tones. Defaults to 16/regular/default.</Muted>
        <div className="c6__stack">
          <Text size="lg" weight="bold">
            Large bold — დიდი გაბედული
          </Text>
          <Text>Base regular — საბაზო რეგულარული. ეს არის ჩვეულებრივი პარაგრაფის ზომა.</Text>
          <Text size="sm" tone="muted">
            Small muted — გადახრილი მოკლე ტექსტი, რომელიც სუსტადაა შეღებილი.
          </Text>
          <Text size="xs" tone="soft" weight="medium">
            Extra-small soft — ლეგენდები, ჯეჯო, ფოტოს ქვეშ.
          </Text>
        </div>

        <Muted className="c6__spacer">Tones</Muted>
        <div className="c6__stack">
          <Text tone="primary" weight="bold">primary</Text>
          <Text tone="accent" weight="bold">accent</Text>
          <Text tone="danger" weight="bold">danger</Text>
          <Text tone="info" weight="bold">info</Text>
          <Text tone="muted">muted</Text>
          <Text tone="soft">soft</Text>
        </div>
      </section>

      {/* Avatar */}
      <section className="c6__section">
        <Heading level={3}>Avatar</Heading>
        <Muted>Initials fallback when no image. Optional level ring + level badge.</Muted>

        <div className="c6__row">
          <Avatar name="Giorgi Khundadze" size={40} />
          <Avatar name="Nino Kiknadze" size={56} />
          <Avatar name="Tornike" size={72} />
          <Avatar
            src="https://i.pravatar.cc/160?img=13"
            name="Demo"
            size={72}
          />
          <Avatar
            src="https://i.pravatar.cc/160?img=22"
            name="Demo"
            size={72}
            level={0.62}
            levelBadge={7}
          />
        </div>
      </section>

      {/* Icon */}
      <section className="c6__section">
        <Heading level={3}>Icon</Heading>
        <Muted>Thin wrapper for inline SVGs. Consistent sizing + color inheritance.</Muted>

        <div className="c6__row">
          <Icon size={24} color="var(--color-primary)" label="check">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12.5l4.5 4.5L19 7.5" />
            </svg>
          </Icon>
          <Icon size={28} color="var(--color-accent)" label="flame">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2c1 3 3 5 3 8a3 3 0 1 1-6 0c0-1.5.5-2.5 1.2-3.4C9 7.5 8 8.3 8 10c-2.5 1.5-4 4-4 7 0 3.9 3.6 7 8 7s8-3.1 8-7c0-6-4.5-9-8-15z" />
            </svg>
          </Icon>
          <Icon size={32} color="var(--color-info)" label="info">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 11v6" />
              <path d="M12 7v.5" />
            </svg>
          </Icon>
          <Icon size={40} color="var(--color-danger)" label="alert">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3l10 18H2L12 3z" />
              <path d="M12 10v5" />
              <path d="M12 17.5v.5" />
            </svg>
          </Icon>
        </div>
      </section>

      <footer className="c6__footer">
        <Muted>
          <b>Cluster 6 review.</b> Look at the heading sizes, check the Georgian renders at every size, verify avatar
          initials, icon colors. Say &ldquo;lock cluster 6&rdquo; when good.
        </Muted>
      </footer>
    </main>
  );
}
